import { render } from "./Main.vue?vue&type=template&id=41ae3da2"
import script from "./Main.vue?vue&type=script&lang=ts"
export * from "./Main.vue?vue&type=script&lang=ts"
script.render = render

export default script